import type { ReactNode } from 'react';

export interface KpiItem {
  label: string;
  value: ReactNode;
  unit?: string | null;
  sub?: ReactNode;
}

export function KpiTile({ label, value, unit, sub }: KpiItem): JSX.Element {
  return (
    <div className="kpi">
      <div className="kpi-l">{label}</div>
      <div className="kpi-v">
        {value}
        {unit ? <span className="unit">{unit}</span> : null}
      </div>
      {sub ? <div className="kpi-sub">{sub}</div> : null}
    </div>
  );
}

export function KpiStrip({ items }: { items: KpiItem[] }): JSX.Element {
  return (
    <div className="kpi-strip">
      {items.map((k, i) => <KpiTile key={i} {...k} />)}
    </div>
  );
}

export function KpiTileLoading(): JSX.Element {
  return (
    <div className="kpi">
      <div className="sk" style={{ width: 100, height: 11 }} />
      <div className="sk" style={{ width: 130, height: 36, marginTop: 2 }} />
    </div>
  );
}
